// Portal API client — talks to /api/portal/* with portal token (separate from main app auth)
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PORTAL_TOKEN_KEY = 'qindex_portal_token';
const PORTAL_USER_KEY = 'qindex_portal_user';

export const portalAuth = {
  getToken: () => localStorage.getItem(PORTAL_TOKEN_KEY),
  getUser: () => {
    try { return JSON.parse(localStorage.getItem(PORTAL_USER_KEY) || 'null'); }
    catch { return null; }
  },
  set: (token, user) => {
    localStorage.setItem(PORTAL_TOKEN_KEY, token);
    localStorage.setItem(PORTAL_USER_KEY, JSON.stringify(user));
  },
  clear: () => {
    localStorage.removeItem(PORTAL_TOKEN_KEY);
    localStorage.removeItem(PORTAL_USER_KEY);
  },
};

const headers = () => ({
  Authorization: `Bearer ${portalAuth.getToken()}`,
  'Content-Type': 'application/json',
});

export const portalApi = {
  login: (email, password) =>
    axios.post(`${BACKEND_URL}/api/portal/login`, { email, password }),
  magicLogin: (magicToken) =>
    axios.post(`${BACKEND_URL}/api/portal/magic-login`, { magicToken }),
  acceptInvite: (inviteToken, password) =>
    axios.post(`${BACKEND_URL}/api/portal/accept-invite`, { inviteToken, password }),
  me: () => axios.get(`${BACKEND_URL}/api/portal/me`, { headers: headers() }),
  listClients: () =>
    axios.get(`${BACKEND_URL}/api/portal/clients`, { headers: headers() }),
  getClient: (clientId) =>
    axios.get(`${BACKEND_URL}/api/portal/clients/${clientId}`, { headers: headers() }),
  addComment: (clientId, content) =>
    axios.post(`${BACKEND_URL}/api/portal/clients/${clientId}/handover-comment`,
      { content }, { headers: headers() }),

  // Phase 1 — section-specific endpoints
  wealthSnapshot: (clientId) =>
    axios.get(`${BACKEND_URL}/api/portal/clients/${clientId}/wealth-snapshot`, { headers: headers() }),
  team: (clientId) =>
    axios.get(`${BACKEND_URL}/api/portal/clients/${clientId}/team`, { headers: headers() }),
  actionItems: (clientId) =>
    axios.get(`${BACKEND_URL}/api/portal/clients/${clientId}/action-items`, { headers: headers() }),
  documentRequests: (clientId) =>
    axios.get(`${BACKEND_URL}/api/portal/clients/${clientId}/document-requests`, { headers: headers() }),
  sharedDocuments: (clientId) =>
    axios.get(`${BACKEND_URL}/api/portal/clients/${clientId}/shared-documents`, { headers: headers() }),
  whatsChanged: (clientId) =>
    axios.get(`${BACKEND_URL}/api/portal/clients/${clientId}/whats-changed`, { headers: headers() }),
  messages: (clientId) =>
    axios.get(`${BACKEND_URL}/api/portal/clients/${clientId}/messages`, { headers: headers() }),
  postMessage: (clientId, content) =>
    axios.post(`${BACKEND_URL}/api/portal/clients/${clientId}/messages`,
      { content }, { headers: headers() }),

  // Phase 2 — Adviser-specific
  clientContext: (clientId) =>
    axios.get(`${BACKEND_URL}/api/portal/clients/${clientId}/client-context`, { headers: headers() }),
  myAuditSummary: () =>
    axios.get(`${BACKEND_URL}/api/portal/me/audit-summary`, { headers: headers() }),
};
